<template>
  <b-dropdown
    variant="cashflow-summary"
    size="md"
    no-caret
    right
    id="popover-cashflow-sync"
  >
    <template #button-content>
      <i class="fa fa-list-alt" aria-hidden="true"></i>
    </template>
    <b-dropdown-text style="width: 240px;">
      Cash Flow Summary
    </b-dropdown-text>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text style="width: 240px;">
      <table id="table_cashflow" v-if="cashflow_summary">
        <tr>
          <td>Opening Balance</td>
          <td>
            {{ cashflow_summary.opening_balance | amount }}
          </td>
        </tr>
        <tr>
          <td>Cash In</td>
          <td>
            {{ cashflow_summary.cash_in | amount }}
          </td>
        </tr>
        <tr>
          <td>Cash Out</td>
          <td>
            {{ cashflow_summary.cash_out | amount }}
          </td>
        </tr>

        <tr>
          <td>Cash Sales</td>
          <td>{{ cashflow_summary.sales.paid_amount | amount }}</td>
        </tr>

        <tr>
          <td>Credit Sales</td>
          <td>
            {{
              (cashflow_summary.sales.total_amount -
                cashflow_summary.sales.paid_amount)
                | amount
            }}
          </td>
        </tr>
        <tr>
          <td>Closing Balance</td>
          <td>
            {{
              (cashflow_summary.opening_balance - cashflow_summary.cash_out) + cashflow_summary.cash_in | amount
            }}
          </td>
        </tr>
      </table>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SummaryDropdown",
  data: () => ({
    loading: false,
    cashflow: {},
  }),
  created: function() {
    this.fetchCashFlowData();
  },
  computed: {
    ...mapState("shops", ["cashflow_summary"]),
  },
  methods: {
    fetchCashFlowData() {
      this.$store.dispatch("shops/fetchCashflowData");
    },
    showModal() {
      this.$refs["SettingsModal"].show();
    },
    hideModal() {
      this.$refs["SettingsModal"].hide();
    },
  },
};
</script>

<style scoped>
#table_cashflow {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#table_cashflow td,
#table_cashflow th {
  padding: 8px;
}

#table_cashflow td {
  color: #087592;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
}

#table_cashflow tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* #table_cashflow tr:hover {
  background-color: #f9f9f9;
} */

#table_cashflow th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f9f9f9;
  color: #5f6983;
}

#popover-cashflow-sync .b-dropdown-text {
  padding: 3px 15px !important;
}
</style>
